import { CNSUser } from "@/models/cns";
import { AUTH_API_BASE, CNS_API_BASE } from "@/config";
import { throwOnProblemResponse } from "@/types/problem-detail";

// Login user with username/password
export async function login(username: string, password: string): Promise<boolean> {
  const formData = new URLSearchParams();
  formData.append('username', username);
  formData.append('password', password);

  const response = await fetch(`${CNS_API_BASE}/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData.toString(),
  });

  if (!response.ok) {
    await throwOnProblemResponse(response, "Login failed");
  }

  return true;
}

// Fetch current authenticated user
export async function fetchCurrentUser(): Promise<CNSUser> {
  const response = await fetch(`${AUTH_API_BASE}/user/current`, {
    credentials: 'include',
  });

  if (!response.ok) {
    await throwOnProblemResponse(response, "Failed to fetch current user");
  }

  return response.json();
}

/** Logout URL for full-page redirect (avoids CORS when backend redirects to swiftcns.ai). */
export function getLogoutUrl(): string {
  return `${CNS_API_BASE}/logout`;
}

/**
 * Logout via API (fetch). Use only when backend does NOT redirect to another origin.
 * For "logout then go to swiftcns.ai", use full-page redirect: window.location.href = getLogoutUrl().
 */
export async function logout(): Promise<void> {
  const response = await fetch(getLogoutUrl(), {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    await throwOnProblemResponse(response, "Logout failed");
  }
}
